import { nonEmptyStringValidator } from '@vista-digital/occ-domain';
import { Validator } from '@vista-digital/validator';
import { defaultOccFilmDisplayText, occFilmDisplayTextValidator } from './film';
import { defaultOccFilterDisplayText, occFilterDisplayTextValidator } from './filter';
import { defaultOccFormDisplayText, occFormDisplayTextValidator } from './form';
import { defaultOccMemberDisplayText, occMemberDisplayTextValidator } from './member';
import { defaultOccOrderDisplayText, occOrderDisplayTextValidator } from './order';
import { defaultOccPriceDisplayText, occPriceDisplayTextValidator } from './price';
import { defaultOccSeatDisplayText, occSeatDisplayTextValidator } from './seat';
import { defaultOccShowtimeDisplayText, occShowtimeDisplayTextValidator } from './showtime';
import { defaultOccSubscriptionDisplayText, occSubscriptionDisplayTextValidator } from './subscription';
export const defaultOccDisplayText = {
    cinemaChainName: 'ABC Cinemas',
    componentErrorTitle: 'Sorry, something went wrong.',
    noSearchResultsFoundMessage: "No results found for '${searchTerm}'",
    film: defaultOccFilmDisplayText,
    filter: defaultOccFilterDisplayText,
    form: defaultOccFormDisplayText,
    member: defaultOccMemberDisplayText,
    order: defaultOccOrderDisplayText,
    price: defaultOccPriceDisplayText,
    seat: defaultOccSeatDisplayText,
    showtime: defaultOccShowtimeDisplayText,
    subscription: defaultOccSubscriptionDisplayText
};
export const occDisplayTextValidator = Validator.object({
    cinemaChainName: nonEmptyStringValidator,
    componentErrorTitle: nonEmptyStringValidator,
    noSearchResultsFoundMessage: nonEmptyStringValidator,
    film: occFilmDisplayTextValidator,
    filter: occFilterDisplayTextValidator,
    form: occFormDisplayTextValidator,
    member: occMemberDisplayTextValidator,
    order: occOrderDisplayTextValidator,
    price: occPriceDisplayTextValidator,
    seat: occSeatDisplayTextValidator,
    showtime: occShowtimeDisplayTextValidator,
    subscription: occSubscriptionDisplayTextValidator
});
//# sourceMappingURL=display-text.js.map